import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { screenSelector } from "@client/selectors/state";
import { type AppState, ScreenType } from "@client/types";
import Menu, { type MenuProps } from "@client/widgets/Menu/component";
import { enhancedMenuItemsSelector } from "./selectors";

import "./style.less";

export const mapStateToProps = (state: AppState): MenuProps & WithIsVisibleHOCProps => {
  return {
    id: "sideMenu",
    className: "menu-onclick menu-vertical",
    items: enhancedMenuItemsSelector(state),
    isVisible: true,
    isClickable: true,
    autoExpandCurrent: screenSelector(state) === ScreenType.Desktop,
    hideSubmenuOnOutsideClick: false,
    showTitles: false
  };
};

export default connectCustom(mapStateToProps)(Menu);
